// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myapps-container {
  padding: 16px;
  border-top-right-radius: 18px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  opacity: 1;
}

.toggle-tabs-costAnalytics {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  overflow: hidden;
}

.toggle-tabs-costAnalytics .toggle-btn {
  border: none;
  font-weight: 500;
  color: #6b7280; 
  background-color: white;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.toggle-tabs-costAnalytics .toggle-btn:hover {
  background-color: #f3f4f6;
}

.toggle-tabs-costAnalytics .toggle-btn.active {
  background-color: #0d6efd; 
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/Pages/MyApps.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".myapps-container {\n  padding: 16px;\n  border-top-right-radius: 18px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  opacity: 1;\n}\n\n.toggle-tabs-costAnalytics {\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.toggle-tabs-costAnalytics .toggle-btn {\n  border: none;\n  font-weight: 500;\n  color: #6b7280; \n  background-color: white;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.toggle-tabs-costAnalytics .toggle-btn:hover {\n  background-color: #f3f4f6;\n}\n\n.toggle-tabs-costAnalytics .toggle-btn.active {\n  background-color: #0d6efd; \n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
